/**
 * Pure, DOM-free carousel index math for the session swipe carousel.
 *
 * The session dots + left/right swipe form a TRUE WRAPAROUND CAROUSEL (Phase 2 of
 * plans/agents-drawer-carousel-reorg.md): there is no boundary, so swiping left on the
 * leftmost session wraps to the rightmost and vice-versa. Co-located here (not in a
 * store) so the setpoint-eval simulator can exercise it under plain `tsx` with NO
 * framework preload shim — same pattern as `pickSleepAdvanceTarget` / `getAgentDotState`
 * but with zero zustand/preact imports.
 *
 *   n   = openTabs.length (the candidate set).
 *   idx = current session's index in openTabs.
 *   dir = 'next' (swipe LEFT → next tab) | 'prev' (swipe RIGHT → previous tab).
 *
 * Modulo wrap (no boundary):
 *   next: (idx + 1) % n
 *   prev: (idx - 1 + n) % n
 *
 * Single-tab (n <= 1) → returns idx (no-op): a cycle of one has nowhere to go.
 * Defensive: an out-of-range idx (e.g. -1 when currentSessionId isn't in openTabs)
 * returns idx unchanged so the caller can bounce-back rather than jump.
 */
export function nextSessionIndex(idx: number, n: number, dir: 'prev' | 'next'): number {
  if (n <= 1) return idx;
  if (idx < 0 || idx >= n) return idx;
  return dir === 'next' ? (idx + 1) % n : (idx - 1 + n) % n;
}
